import { unsafeCSS, html } from "lit";
import { classMap } from "lit/directives/class-map.js";
import { e } from "../../scoped-registry-mixin-2fqf-E5n.js";
import { LeafElement } from "../../components/leaf-element.js";
const styles = ":host {\n  display: block;\n}\n:host .chc-c-product-card__footer-compare {\n  padding: var(--leaf-spacing-16) var(--leaf-spacing-32);\n}";
const _CHCProductCardFooterCompare = class _CHCProductCardFooterCompare extends e(LeafElement) {
  render() {
    const componentClassName = {
      "chc-c-product-card__footer-compare": true
    };
    return html`<div class=${classMap(componentClassName)}>
      <slot></slot>
    </div>`;
  }
};
_CHCProductCardFooterCompare.styles = unsafeCSS(styles);
let CHCProductCardFooterCompare = _CHCProductCardFooterCompare;
export {
  CHCProductCardFooterCompare
};
//# sourceMappingURL=product-card-footer-compare.component.js.map
